<script lang="ts">
  import SignUp from '../Organizations/SignUp.svelte'
  import Retro from '../Game/Retro.svelte'
  import UnAuthedUserTopBarPage from '../Navigation/TopLevelPages/NoSubscriptionUserTopBarPage.svelte'
  import { app_user } from '../Users/observables'
  import LandingPage from '../StaticPages/LandingPage.svelte'
  import TopBarPage from '../Navigation/TopLevelPages/TopBarPage.svelte'
  import VerifyEmailCta from '../Navigation/VerifyEmailCta.svelte'
  import LapsedSubscriptionCta from '../Navigation/LapsedSubscriptionCTA.svelte'
</script>

{#if $app_user.state === 'Loading'}
  <p>Loading...</p>
{:else if $app_user.state === 'NoAccount'}
  <LandingPage />
{:else if $app_user.state === 'NoSubscription'}
  <UnAuthedUserTopBarPage>
    <SignUp />
  </UnAuthedUserTopBarPage>
{:else if $app_user.state === 'UnverifiedEmail'}
  <TopBarPage>
    <VerifyEmailCta />
  </TopBarPage>
{:else if $app_user.state === 'LapsedSubscription'}
  <TopBarPage>
    <LapsedSubscriptionCta />
  </TopBarPage>
{:else}
  <Retro user={$app_user} />
{/if}
